export enum LegacyActionEvent {
  CLICK_FROM = 'Click from',
  HAWK_APPEARED = 'Hawk appeared',
  VIEWED = 'viewed',
  ITEM_VIEWED = 'item viewed',
}
